import { AppEnv } from "./constants";

const env = process.env.NODE_ENV || AppEnv.DEVELOPMENT;
export const getEnv = () => env as AppEnv;

const appEnv = process.env.CO_ENV || AppEnv.DEVELOPMENT;
export const getAppEnv = () => appEnv as AppEnv;

export const isProdEnv = env === AppEnv.PRODUCTION || env === AppEnv.STAGING;
export const isDevEnv = env === AppEnv.DEVELOPMENT;
